import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

function BillingSuccess() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    console.log('Payment successful! Session:', sessionId);
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="bg-white rounded-lg shadow-md p-8 text-center max-w-md w-full">
        <h1 className="text-2xl font-bold text-gray-900 mb-3">🎉 Payment Successful!</h1>
        <p className="text-gray-600 mb-6">Your subscription is now active.</p>
        <a
          href="/super-admin/dashboard"
          className="inline-flex items-center justify-center px-4 py-2 rounded-md bg-indigo-600 text-white hover:bg-indigo-700 transition-colors"
        >
          Go to Dashboard
        </a>
      </div>
    </div>
  );
}

export default BillingSuccess;
